import tmhRequest from '@/config/tmhRequest'

export default {
    dealAuthUrl: function (data) {
        return tmhRequest({
            url: '/common/tmh/meituan/dealauthurl',
            method: 'post',
            params: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/common/meituan.js